import httpStatusCode from '../../../../api-server/constants/httpStatusCode';
import {
    setAllsureApplicationApiStatus,
    setAllsureApplicationQuoteDetails,
} from '../../../actions/allsureInsurance/referenceData';
import { API_CALL_STATUS } from '../../../reducers/status';
import { getGlobalPaymentFrequency } from '../../../selectors/allsureInsurance/homeDetails';
import { getCallMeBackPayload, getEmailSubjectLabel, getEstimatedPremiumBreakdown, getNegotiatedPremiumBreakdown, getTotalPreferredPremium } from '../../../selectors/allsureInsurance/motorDetails';
import axios from 'axios';
import { getPersonalDetailsForm, getPersonalDetailsMaped } from '../../../selectors/allsureInsurance/personalDetails';
import {  getPurchasePersonalDetailsForm } from '../../../selectors/allsureInsurance/purchasePersonalDetails';
import { getAllsureReferenceNumber, getQuoteTotalAmountMonthly } from '../../../selectors/allsureInsurance/referenceData';
import { getPurchaseDetails } from '../../../selectors/allsureInsurance/purchaseAdditionalHomeMotorDetails';
import { navigateNext } from '../../../actions/digitalOnboarding/routing';
import { submitPolicy } from '../../../actions/allsureInsurance/policyRequests';
import { navigateToCallMeBack } from '../../../actions/allsureInsurance/routing';

export const quotingMailService = (store, next, action) => {
    const state=store.getState();
    (async () => {

        store.dispatch(setAllsureApplicationApiStatus(API_CALL_STATUS.PENDING));
      
        const personalDetail= getPersonalDetailsForm(state);
        const productLabel=getEmailSubjectLabel(state);
        const referenceNumber=getAllsureReferenceNumber(state);
        const monthlyQuoteAllproducts = getQuoteTotalAmountMonthly(state)
        const paymentFrequency = getGlobalPaymentFrequency(state)
        const purchasePersonalDetails=getPurchasePersonalDetailsForm(state)
        const personalDetailsSummary= getPersonalDetailsMaped(state)
        const {fullName,cellphoneNumber,email}=personalDetail
        const name=action.value==='purchaseMail' ? purchasePersonalDetails.fullname : fullName

        const {motorMaped,homeContentMaped,homeMaped} = getCallMeBackPayload()(state)
        const personalMaped=[{title:'Personal Details',data: personalDetailsSummary }]
        const purchaseDetails=action.value==="purchaseMail" ? getPurchaseDetails(state) : personalMaped
        const estimatedPremiumMap = getEstimatedPremiumBreakdown(state);
        const preferPremiumMap = getNegotiatedPremiumBreakdown(state);
        const dataEmailObj = [...homeMaped,...homeContentMaped,...motorMaped,...purchaseDetails,]
        const totalPreferPremium = getTotalPreferredPremium(state);

        const sampleRequestBody = {
            firstName:name?.value?.split(' ')[0],
            lastName:name?.value?.split(' ')[1],
            contactNumber:cellphoneNumber?.value,
            subject:`Web: ${productLabel} : ${name?.value} - REF: ${referenceNumber}`,
            userDataFields: dataEmailObj,
            estimatedPremiumMap:estimatedPremiumMap,
            preferPremiumMap:preferPremiumMap,
            templateType:action.value==="purchaseMail" ? "ALLSURE_QUOTE_CUSTOMER" :"ALLSURE_NEGOTIATE_PREMIUM_TEMPLET",
            monthlyPremium: paymentFrequency==='Monthly' ? +((monthlyQuoteAllproducts)/12)?.toFixed(2)+6  : null,
            yearlyPremium:paymentFrequency!=='Monthly'?(+(monthlyQuoteAllproducts ?? 0)):null,
            referenceNumber: referenceNumber??"",
            // email: action.value==="purchaseMail" ? email.value : null,
            email: null,
            preferPremium :totalPreferPremium
        }   
        const quoteData = await sendEmailNotification(sampleRequestBody);
        if (quoteData && quoteData.status === httpStatusCode.OK) {
          if(action.value==="purchaseMail" )  {
            store.dispatch(submitPolicy())
          }else{
            store.dispatch(setAllsureApplicationApiStatus(API_CALL_STATUS.SUCCESS));
            store.dispatch(navigateToCallMeBack())
          }
           
            
        } else {
            store.dispatch(setAllsureApplicationApiStatus(API_CALL_STATUS.FAILURE));
        }
    })();
    return next(action);
};

export const sendEmailNotification = async (requestBody) => {
    try {
        const response = await axios({
            url: 'om-api/submit-notification/submitNotificationEmail',
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            data: requestBody,
        });
        return response;
    } catch (error) {
        return null;
    }
};

